import JSZip from 'jszip'
import moment from 'moment'
import _ from 'lodash'
import { saveAs } from 'file-saver'

export const CreateExportFile = (oasisFiles) => {
  var zip = new JSZip()
  _.forEach(oasisFiles, (a, i) => {
    zip.file(`${a.FirstName}${a.LastName}${moment(a.CompletedDate).utc().format('YYYYMMDD')}${i}.xml`, a.ExportXML)
  })
  zip.generateAsync({ type: 'blob' })
    .then(function (content) {
      saveAs(content, `OasisFile${moment().utc().format('YYYYMMDDTHHmm')}.zip`)
    })
}

export const OBJtoXML = (obj) => {
  var xml = ''
  for (var prop in obj) {
    xml += obj[prop] instanceof Array ? '' : '<' + prop + '>'
    if (obj[prop] instanceof Array) {
      for (var array in obj[prop]) {
        xml += '<' + prop + '>'
        xml += OBJtoXML(Object.create(obj[prop][array]))
        xml += '</' + prop + '>' + '\n'
      }
    } else if (typeof obj[prop] === 'object') {
      xml += OBJtoXML(Object.create(obj[prop]))
    } else {
      xml += obj[prop]
    }
    xml += obj[prop] instanceof Array ? '' : '</' + prop + '>' + '\n'
  }
  xml = xml.replace(/<\/?[0-9]{1,}>/g, '')
  return xml
}
